import {
  CheckNotes,
  InspectionCase,
  InspectionPreactionSystemCase,
  InspectionPreactionSystemCaseDto
} from '../../inspection-cases';

export class PreactionSystemsInstallationDto extends InspectionCase {
  preactionSystemType?: InspectionPreactionSystemCaseDto;
  manufacturerNameAndModel?: InspectionCase;
  systemOperationDescription?: InspectionCase;
}

export class PreactionSystemsInstallation extends PreactionSystemsInstallationDto {
  constructor(
    data: PreactionSystemsInstallationDto = { title: 'מערכות פעולה מקדימה' }
  ) {
    super(data);
    this.preactionSystemType = new InspectionPreactionSystemCase({
      ...data.preactionSystemType,
      title:
        'ציין את סוג המערכת: single interlock, non interlock, double interlock'
    });
    this.manufacturerNameAndModel = new InspectionCase({
      ...data.manufacturerNameAndModel,
      title: 'שם היצרן ודגם תחנת ההפעלה'
    });
    this.systemOperationDescription = new InspectionCase({
      ...data.systemOperationDescription,
      title: 'תאר את אופן הפעלת המערכת: גלאים / מערכת לחץ אויר'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.preactionSystemType.isApplicable ||
        this.preactionSystemType.isPassed) &&
        (!this.manufacturerNameAndModel.isApplicable ||
          this.manufacturerNameAndModel.isPassed) &&
        (!this.systemOperationDescription.isApplicable ||
          this.systemOperationDescription.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.preactionSystemType.getNotes(),
      ...this.manufacturerNameAndModel.getNotes(),
      ...this.systemOperationDescription.getNotes()
    ];
  }
}
